<template>
  <div class="impressum-page">
      <h1 v-html="title"></h1>
      <section class="section">
        <div v-if="content" v-html="content"></div>
        <div v-else>
          <p>Dies ist das Impressum. Inhalte können im Admin angepasst werden.</p>
        </div>
      </section>
    </div>
</template>

<script>
import { useConfig } from '../composables/useConfig.js';

export default {
  name: "ImpressumPage",
  setup() {
    const { config, loadConfig } = useConfig();
    loadConfig();
    return { config };
  },
  computed: {
    title() {
      return this.config?.impressumPage?.title || 'Impressum';
    },
    content() {
      return this.config?.impressumPage?.content || null;
    }
  }
};
</script>

<style scoped>
.impressum-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 1.5rem;
}

.impressum-page h1 {
  margin-bottom: 1rem;
}

.impressum-page section {
  margin-bottom: 1.25rem;
}
</style>
        